import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    selectIsBtnNewNoteGrabEnabled,
    selectIsBtnNewTableGrabEnabled,
    selectScale,
} from '../../../redux/diagram/diagram.selectors';

import './DraggableTable.scss';

export const DraggableTable = () => {
    const isBtnNewTableGrabEnabled = useSelector(
        selectIsBtnNewTableGrabEnabled
    );
    const isBtnNewNoteGrabEnabled = useSelector(selectIsBtnNewNoteGrabEnabled);
    const scale = useSelector(selectScale);

    const [mouseXY, setMouseXY] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleDocumentMouseMove = (event) => {
            const mouseX = event.clientX - 160 * scale;
            const mouseY = event.clientY - 40 * scale;

            setMouseXY({ x: mouseX, y: mouseY });
        };

        document.addEventListener('mousemove', handleDocumentMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleDocumentMouseMove);
        };
    }, [isBtnNewTableGrabEnabled, isBtnNewNoteGrabEnabled, scale]);

    const tableElement = (
        <div
            className={`drag-element-table ${isBtnNewTableGrabEnabled && 'selected'
                }`}
            style={{
                left: `${mouseXY.x}px`,
                top: `${mouseXY.y}px`,
                width: `${320 * scale}px`,
                height: `${84 * scale}px`,
                borderRadius: `${3.5 * scale}px`,
            }}
        >
            <div
                className="drag-element-table-header"
                style={{
                    height: `${41.25 * scale}px`,
                    borderTopLeftRadius: `${3.5 * scale}px`,
                    borderTopRightRadius: `${3.5 * scale}px`,
                    borderBottomWidth: `${1.25 * scale}px`,
                }}
            ></div>
        </div>
    );

    const noteElement = (
        <div
            className={`drag-element-table ${isBtnNewNoteGrabEnabled && 'selected'
                }`}
            style={{
                left: `${mouseXY.x}px`,
                top: `${mouseXY.y}px`,
                width: `${320 * scale}px`,
                height: `${180 * scale}px`,
            }}
        >
            <div
                className="drag-element-table-header"
                style={{
                    height: `${40 * scale}px`,
                }}
            ></div>
        </div>
    );

    return (
        <div>
            {isBtnNewTableGrabEnabled && tableElement}
            {isBtnNewNoteGrabEnabled && noteElement}
        </div>
    );
};

export default DraggableTable;
